import yup from "src/validators/yup.Module";

export enum SubModuloEnum {
  NFCe = 1,
  NFe = 2,
}

export enum ConfiguracaoTipoEnum {
  IdToken = 1,
  CSC = 2,
  TipoAmbiente = 3,
  TipoEmissao = 4,
  Serie = 5,
}

export interface ConfiguracoesFiltrarParams {
  id?: number;
  subModulo?: number;
  tipoConfiguracao?: number;
  usuarioId?: number;
}

export interface ConfiguracaoCadastroDto {
  usuarioId?: number;
  subModulo?: SubModuloEnum | "";
  tipoConfiguracao?: ConfiguracaoTipoEnum | "";
  configuracaoValor?: string;
}

export interface ConfiguracaoPayload {
  id?: number;
  subModulo: number;
  tipoConfiguracao: number;
  configuracaoValor: string;
  usuarioId?: number;
}

export interface ApiConfiguracaoItemDto {
  id: number;
  subModulo: string;
  tipoConfiguracao: string;
  configuracaoValor: string;
}

export const subModuloOptions = [
  { value: SubModuloEnum.NFCe, label: "NFCe" },
  { value: SubModuloEnum.NFe, label: "NFe" },
];

export const configuracaoOptions = {
  [SubModuloEnum.NFCe]: [
    { value: ConfiguracaoTipoEnum.IdToken, label: "IdToken" },
    { value: ConfiguracaoTipoEnum.CSC, label: "CSC" },
    { value: ConfiguracaoTipoEnum.TipoAmbiente, label: "TipoAmbiente" },
    { value: ConfiguracaoTipoEnum.TipoEmissao, label: "TipoEmissao" },
    { value: ConfiguracaoTipoEnum.Serie, label: "Serie" },
  ],
  [SubModuloEnum.NFe]: [
    { value: ConfiguracaoTipoEnum.TipoAmbiente, label: "TipoAmbiente" },
    { value: ConfiguracaoTipoEnum.TipoEmissao, label: "TipoEmissao" },
  ],
};

export const SistemaCadastroSchema = yup.object().shape({
  subModulo: yup
    .number()
    .typeError("Selecione o submódulo.")
    .required("Selecione o submódulo."),
  tipoConfiguracao: yup
    .number()
    .typeError("Selecione a configuração.")
    .required("Selecione a configuração."),
  configuracaoValor: yup
    .string()
    .required("Digite o valor da configuração.")
    .min(1, "O valor deve ter no mínimo 1 caractere."),
});
